import React from 'react';
import {DropDownItem} from '../../../services/configurations-areas/fields-definitions/drop-down-field-definition';
import {Check} from '@sparkware/app-utils';
import {observer} from 'mobx-react';
import {LauncherComponentWithState} from '../../base-components/launcher-component-with-state';
import {TextValueEditorComponent} from '../text-value-editor/text-value-editor.component';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import {INPUT_MIN_PADDING, INPUT_MIN_WIDTH} from '../../../launcher-style-consts';
import {IConfigFieldDefinition} from '../../../services/configurations-areas/fields-definitions/config-field-definition-base';

export interface DropDownValueEditorComponentProps {
    fieldDefinition: IConfigFieldDefinition;
    items: DropDownItem[];
    renderOtherValueInput?: () => React.ReactNode;
}

interface DropDownValueEditorComponentState {
    isOtherOpen: boolean;
}

const DEFAULT_VALUE = 'DefaultValue';
const OTHER_VALUE = 'OtherValue';

@observer
export class DropDownValueEditorComponent extends LauncherComponentWithState<DropDownValueEditorComponentProps, DropDownValueEditorComponentState> {
    state: DropDownValueEditorComponentState = {
        isOtherOpen: false
    };


    componentDidMount() {
        super.componentDidMount();
        this.reaction(
            () => this.services.configsStorage.timeWhenResetWasApplied,
            () => this._hideOtherValue());

    }

    private _renderDropDownOption(option: DropDownItem) {
        if(Check.isNullOrUndefined(option.text)) {
            return (<MenuItem key={option.value} value={option.value}>{option.value}</MenuItem>);
        } else {
            return (<MenuItem key={option.text} value={option.value}>{option.text}</MenuItem>);
        }
    }

    private _findValueInTheItems(selectedValue: string): any {
        if(Check.isNullOrUndefined(selectedValue)) {
           return undefined;
        }

        for(let i = 0; i < this.props.items.length; i++) {
            if(selectedValue.toString() === this.props.items[i].value.toString()) {
                return this.props.items[i].value;
            }
        }
    }

    private _showOtherValue() {
        this.setState({
            isOtherOpen: true
        });
    }

    private _hideOtherValue() {
        this.setState({
            isOtherOpen: false
        });
    }

    private _onChangeHandler = (event) => {
        if(event.target.value ===  OTHER_VALUE) {
           this._showOtherValue();
           this.props.fieldDefinition.resetToDefault();
        } else {
            if( event.target.value === DEFAULT_VALUE) {
                this.props.fieldDefinition.resetToDefault();
            } else {
                this.props.fieldDefinition.setValue(this._findValueInTheItems(event.target.value));
            }
            this._hideOtherValue();
        }
    };


    private _renderOtherInput(shouldRender: boolean) {
        if(shouldRender) {
            if(this.props.renderOtherValueInput) {
                return (<div>{this.props.renderOtherValueInput()}</div>);
            }
            return (<div><TextValueEditorComponent placeholder={`Other ${this.props.fieldDefinition.title}`} fieldDefinition={this.props.fieldDefinition} /></div>);
        }

        return null;
    }

    private _computeValues(): {selectedValue: any; otherValue: any; shouldRenderOtherValue: boolean} {
        let currentValue = this.props.fieldDefinition.getValue();
        let selectedValue = null;
        let shouldForceShowOther = false;

        if(Check.isUndefined(currentValue)) {
            if(this.state.isOtherOpen) {
                selectedValue = OTHER_VALUE;
            } else {
                selectedValue = DEFAULT_VALUE;
            }
        } else {
            let existingValue = this._findValueInTheItems(currentValue);
            if(Check.isUndefined(existingValue)) {
                selectedValue = OTHER_VALUE;
                shouldForceShowOther = true;
            } else {
                selectedValue = existingValue;
            }
        }

        return {
            selectedValue: selectedValue,
            otherValue: currentValue,
            shouldRenderOtherValue: this.state.isOtherOpen || shouldForceShowOther
        };
    }


    private _compareItems = (i1: DropDownItem, i2: DropDownItem) => {
        if(i1.text && i2.text) {
            return i1.text < i2.text ? -1 : 0;
        } else {
            return i1.value < i2.value ? -1 : 0;
        }
    };

    render() {
        let values = this._computeValues();
        let labelId = `${this.props.fieldDefinition.configurationKey}-label`;
        return (
            <div style={{padding: INPUT_MIN_PADDING}}>
                <FormControl style={{minWidth: INPUT_MIN_WIDTH}}>
                    <InputLabel id={labelId}>
                        {this.props.fieldDefinition.title}
                    </InputLabel>
                    <Select value={values.selectedValue} onChange={this._onChangeHandler} labelId={labelId}>
                        <MenuItem key={DEFAULT_VALUE} value={DEFAULT_VALUE}>{"Default"}</MenuItem>
                        {this.props.items.sort(this._compareItems).map(option => this._renderDropDownOption(option))}
                        <MenuItem key={OTHER_VALUE} value={OTHER_VALUE}>{"Other"}</MenuItem>
                    </Select>

                </FormControl>
                {this._renderOtherInput(values.shouldRenderOtherValue)}
            </div>
        )

    }
}